import type { ThemeConfig } from 'antd';
import {theme} from "antd";

const config: ThemeConfig = {
    algorithm: theme.darkAlgorithm,
};

export default config;